import { ListItem } from '../ListItem'
import { RoleListItemContent } from '../RoleListItemContent'

function RoleListItem(props) {
  return <ListItem {...props} Content={RoleListItemContent} />
}

export default RoleListItem
